import { graphql } from 'react-relay';
import type { Hubs_Pagination_Query$variables } from './__generated__/Hubs_Pagination_Query.graphql';

export type Hubs_Pagination_Fragment$args = Hubs_Pagination_Query$variables;

export type {
  Hubs_Pagination_Fragment$data,
  Hubs_Pagination_Fragment$key,
} from './__generated__/Hubs_Pagination_Fragment.graphql';
export const HubsPaginationFragment = graphql`
  fragment Hubs_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToHubConnectionWhereArgs" }
  )
  @refetchable(queryName: "Hubs_Pagination_Query") {
    hubs(first: $first, after: $after, where: $where) @connection(key: "Hubs_Pagination_Fragment_Connection_hubs") {
      __id
      edges {
        node {
          ...Hub_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export * from './__generated__/Hubs_Query.graphql';
export const HubsQuery = graphql`
  query Hubs_Query($first: Int = 24, $after: String = null, $where: RootQueryToHubConnectionWhereArgs = { statusIn: [PUBLISH, HIDDEN, DRAFT, PENDING], search: null}) {
    ...Hubs_Pagination_Fragment
    @arguments(
        first: $first
        after: $after
        where: $where
      )
  }
`;

export const HubsFragment = graphql`
  fragment Hub_Fragment on Hub {
    __id
    id
    databaseId
    title
    description
    slug
    status
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    created
    modified
    template
    group
    postOrder
    author {
      ...Frags_Wiz_Author_Fragment @relay(mask: false)
    }
    userId
    userMeta {
      name
      description
      role
      imageId
      image {
        id
        ...Media_Url_Fragment @relay(mask: false)
        title
      }
    }
    metadata {
      design {
        borderRadius
      }
      shareIcons {
        icon
        title
        url
      }
      navMeta {
        icon
        title
        znglistId
        znglist {
          id
          title
          znglist {
            znglyContents {
              ... on ZnglyVideo {
                id
                znglyContent {
                  featuredImageFile {
                    ...Media_Url_Fragment @relay(mask: false)
                  }
                  featuredImageLink
                  contentFile {
                    ...Media_Url_Fragment @relay(mask: false)
                  }
                  contentLink
                  contentMediaName
                  contentMediaType

                }
              }
            }
          }
        }
      }
    }
    connectionHubToHps(where: { order: ASC, orderBy: PageOrder }) {
      edges {
        node {
          pageId
          pageOrder
          pageTitle
          pageIcon
          hubPage(where: { statusIn: [PUBLISH, DRAFT] }) {
            node {
              id
              title
              description
              form {
                node {
                  ...Frags_Frontend_Form_Fragment @relay(mask: false)
                }
              }
              connectionHpToCs(first: 100, where: { order: ASC, orderBy: CatalogOrder }) {
                edges {
                  node {
                    catalogId
                    catalog {
                      node {
                        ...ZnglyVideo_Single_Fragment @relay(mask: false)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export type {
  Hub_Single_Query,
  Hub_Single_Query$data,
  Hub_Single_Query$variables,
} from './__generated__/Hub_Single_Query.graphql';
export const HubSingleQuery = graphql`
  query Hub_Single_Query($id: ID!) {
    hub(id: $id) {
      ...Hub_Fragment @relay(mask: false)
    }
  }
`;

export type {
  Hub_Frontend_Single_Query,
  Hub_Frontend_Single_Query$data,
  Hub_Frontend_Single_Query$variables,
} from './__generated__/Hub_Frontend_Single_Query.graphql';
export const HubFrontendSingleQuery = graphql`
  query Hub_Frontend_Single_Query($id: ID!, $idType: HubIdType!) {
    hub(id: $id, idType: $idType) {
      id
      author {
        ...Frags_Wiz_Author_Fragment @relay(mask: false)
      }
      title
      description
      slug
      status
      template
      group
      user {
        node {
          ...Frags_Frontend_User_Meta_Fragment @relay(mask: false)
        }
      }
      userMeta {
        name
        description
        role
        imageId
        image {
          id
          ...Media_Url_Fragment @relay(mask: false)
          title
        }
      }
      metadata {
        design {
          borderRadius
        }
        shareIcons {
          icon
          title
          url
        }
        navMeta {
          icon
          title
          znglist {
            id
            title
            author {
              node {
                name
              }
            }
            znglist {
              znglyContents {
                ... on ZnglyVideo {
                  id
                  ...ZnglyVideo_Single_Fragment @relay(mask: false)
                }
              }
            }
          }
        }
      }
      connectionHubToHps(where: { order: ASC, orderBy: PageOrder }) {
        edges {
          node {
            pageId
            pageIcon
            pageTitle
            pageOrder
            hubPage(where: {statusIn: [PUBLISH, DRAFT]}) {
              node {
                id
                title
                status
                author {
                  node {
                    name
                  }
                }
                form {
                  node {
                    ...Frags_Frontend_Form_Fragment @relay(mask: false)
                  }
                }
                connectionHpToCs(first: 100, where: { order: ASC, orderBy: CatalogOrder }) {
                  edges {
                    node {
                      catalogId
                      catalog {
                        node {
                          ...ZnglyVideo_Single_Fragment @relay(mask: false)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
